import { Collapse, Input, InputNumber, Modal } from 'antd'
import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { utility } from '../../../helpers/loader';
import { setPageLoader } from '../../../redux/features/utils.slice';
import { getInspectionHistory, getOOSHistory } from '../../../Services/LocomotiveServices';
import Company from '../Table.js/Company.inspection';
import Federal from '../Table.js/Federal.inspection';
import OutOfServiceDetails from '../Table.js/OutOfServiceDetails.inspection';

const { Panel } = Collapse;

const InspectionModal = ({ inspectionModal, setInspectionModal, locomotiveID, setRefresh, refresh }) => {

    const [data, setData] = useState([])
    const [days, setDays] = useState(null)
    const [editingKey, setEditingKey] = useState('');



    const debounce = (cb, delay = 1000) => {
        let timeout;
        return (...args) => {
            clearTimeout(timeout)
            timeout = setTimeout(() => {
                cb(...args)
            }, delay);
        }
    }

    const panels = [
        {
            key: '1',
            header: 'Federal',
            content: <Federal data={data?.fed_com?.federal} />,
        },
        {
            key: '2',
            header: 'Company',
            content: <Company data={data?.fed_com?.company} />,
        },
        {
            key: '3',
            header: 'Out of service details',
            content: <div style={{ display: "flex", flexDirection: "column", gap: "10px" }} className="oss-inspection">
                <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                    <InputNumber value={days} onChange={debounce(e => setDays(e))} style={{ width: "20%" }} placeholder="Filter by days (Greater than)" min={0} />
                </div>
                <OutOfServiceDetails data={data?.oos} setRefresh={setRefresh} setEditingKey={setEditingKey} editingKey={editingKey} />

            </div>
        },
    ];

    const fetchInspection = async () => {
        let inspection_data = await getInspectionHistory(locomotiveID)
        setData(prev => { return { ...prev, fed_com: inspection_data?.data } })
    }

    const fetch_oos_inspection = async () => {
        utility?.dispatch(setPageLoader({ pageName: "oosTable", flag: true }))
        let oos_inspection_data = await getOOSHistory(locomotiveID, { days: days || 0 })
        if (oos_inspection_data?.httpStatus === 200) {
            utility?.dispatch(setPageLoader({ pageName: "oosTable", flag: false }))
            setData(prev => { return { ...prev, oos: oos_inspection_data?.data?.rows } })
        }
        utility?.dispatch(setPageLoader({ pageName: "oosTable", flag: false }))

    }

    useEffect(() => {
        fetchInspection()
    }, [])

    useEffect(() => {
        fetch_oos_inspection()
    }, [days, refresh])

    return (
        <Modal
            open={inspectionModal}
            onCancel={() => {
                setInspectionModal(false)
                setEditingKey('')
            }}
            footer={null}
            width={"70%"}
            title={<strong>Scheduled Inspection Details</strong>}
        >
            <Collapse
                accordion
                defaultActiveKey={'1'}
            >
                {panels.map(panel => (
                    <Panel header={panel.header} key={panel.key}>
                        {panel.content}
                    </Panel>
                ))}
            </Collapse>
        </Modal >
    )
}

export default InspectionModal